import React, { useEffect, useState } from 'react';
import './Home.css';
import googlePlayBadge from '../Images/googleplayimage.svg';
import appStoreBadge from '../Images/appleplayimage.svg';
import qrCode from '../Images/qr-code.png';

const sentences = [
  'Seamless Transactions in an Instant.',
  'Empowering Your Future with Effortless Cashless Payments',
];

const Home = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % sentences.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="home-video-container">
      <video
        className="home-bg-video"
        src={require('../Images/videos.mp4')}
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="home-animated-text">
        <span key={current} className="home-fade-in">
          {sentences[current]}
        </span>
      </div>
    </div>
  );
};

export default Home;